module.exports = __webpack_public_path__ + "static/media/KM.dde4553a.svg";